<template>
  <div>
    <div class="redirectCls" v-if="redirect">
      <h1>{{ t("redirect") }}</h1>
    </div>
    <div class="radio-box" v-else>
      <div class="font-style">{{ t("signin")}}</div><br>
      <wb-radio-group class="radio-align">
      <div v-for="(item, index) in providers" v-bind:key="index">
        <wb-radio-button class="padding-left" id="id_{{ index+1 }}" name="name_{{ index+1 }}" :value="item" @click="setSelectedItem(item)" >{{ item }}</wb-radio-button>
      </div>
      </wb-radio-group>
      <wb-button variant="primary" size="m" @click="onSelectItem()" v-if="radioChecked">{{ t("next") }}</wb-button>
      <wb-button variant="primary" size="m" @click="onSelectItem()" disabled v-else>{{ t("next") }}</wb-button>
    </div>
    <div id="overlay" :style="{ display: overlayDisplay }">
      <div id="text">
        <loader />
      </div>
    </div>
    <br>
    <div class="mb-20">
      <p v-if="showError"  style="color: red;" id="error">
        {{ t(this.errorResponse) }}
      </p>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import loader from "../components/LoaderAnimation.vue";
import axios from "axios";
import JSEncrypt from "jsencrypt";
export default {
  name: 'ProvidersList',
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  data(){
    return{
      providers: [],
      selectedItem: "",
      redirect: false,
      overlayDisplay: "none",
      showError: false,
      errorResponse: "",
      handle: "",
      ciam: "",
      fin: "",
      expiry: "",
      InCar: false,
      hu: "",
      placeHolder : "",
      domain: "",
      radioChecked: false,
      cod: ""
    }
  },
  components:{loader},
  beforeMount() {
    axios
        .get("/api/providerList",{params:{ hu: this.$route.query.hu.replaceAll("\\",""), cod: this.$route.query.cod }})
        .then(response => {
          this.providers = response.data
        })
        .catch();
  },
  mounted() {
    this.handle = this.$route.query.handle;
    this.expiry = this.$route.query.expiry;
    this.ciam = this.$route.query.ciam;
    this.fin = this.$route.query.fin;
    this.hu = this.$route.query.hu.replaceAll("\\","");
    this.locale = this.$route.query.locale;
    this.providers = this.$route.providers;
    if (this.hu === "3") {
      this.InCar = true;
      this.placeHolder = "calpasswordplaceholder"
    }else {
      this.placeHolder = "passwordplaceholder"
    }
  },
  methods:{
    setSelectedItem(provider){
      this.selectedItem=provider;
      this.radioChecked=true;
    },
    onSelectItem(){
      //console.log("selectedItem: "+this.selectedItem);

      //alert(this.selectedItem);
      if(this.selectedItem.includes("Google")){
        this.domain="abc@gmail.com";
      }else if(this.selectedItem.includes("iCloud")){
        this.domain="abc@icloud.com";
      }else if(this.selectedItem.includes("Yahoo")){
        this.domain="abc@yahoo.com";
      }else if(this.selectedItem.includes("Office365")){
        this.domain="abc@outlook.com";
      }else if(this.selectedItem.includes("Others")){
        localStorage.setItem("emailDomain","OTHERS");
        this.$route.query.locale = this.locale;
        this.$router.push({path:'/sign-in', query: this.$route.query});
        return;
      }else if(this.selectedItem.includes("t-online")){
        this.domain="abc@t-online.de";
      }else if(this.selectedItem==""){
        return;
      }else if(this.selectedItem.includes("Business")){
        this.domain="abc@mercedes-benz.com";
      }
      //console.log("domain:"+this.domain);


      const pubKeyBase64 = this.$cookies.get("casPubKey");
      if (pubKeyBase64) {
        let buff = new Buffer(pubKeyBase64, 'base64');
        let pubKey = buff.toString('ascii');
        let encryptObj = new JSEncrypt({default_key_size: 2048})
        encryptObj.setPublicKey(pubKey);
        let encryptedMail = encryptObj.encrypt(this.domain);
        //console.log("decoding casPubKey"+this.domain)
        this.callProvider(encryptedMail);
      } else {
        this.showError = true;
        this.errorResponse = "qrcodeError";
      }

    },
    callOverlayToggle() {
      if (this.overlayDisplay == "block") {
        this.overlayDisplay = "none";
      } else {
        this.overlayDisplay = "block";
      }
    },
    getAuthParam() {
      return {
        expiry: this.expiry,
        fin: this.fin,
        ciam: this.ciam,
        handle: this.handle,
        locale: this.locale,
      };
    },
    getProviderConfig() {
      let config = {
        crossDomain: true,
        mode: "no-cors",
        headers: this.getAuthParam(),
      };
      config.headers.Mail = this.domain;
      config.headers.locale = this.locale;
      config.headers.Headunit = this.hu;
      return config;
    },
    callProvider(mailId)
    {
      this.showError = false;
      this.callOverlayToggle();
      var outer = this;
      let body = this.getAuthParam();
      body.mailId = mailId;
      body.locale = this.locale;
      body.hu = this.hu;
      axios
          .post("/api/provider", body, this.getProviderConfig())
          .then(function (response)
          {
            outer.callOverlayToggle();
            outer.showError = false;
            outer.errorResponse = "";
            if (response.headers && response.headers.location) {
              //console.log("in redirect: "+mailId);
              outer.redirect = true;
              window.location.href = response.headers.location;
              document.addEventListener("visibilitychange", () => {
                 outer.redirect=false;
              });
              //setTimeout(function() { outer.redirect=false;}, 10000);
            } else {
             //console.log("in localstorage: "+ outer.domain);
              let emailDomain = outer.domain;
              emailDomain= emailDomain.split('@')[1].toUpperCase();

              if(emailDomain.includes("YAHOO")) {
                localStorage.setItem("emailDomain", "YAHOO");
                outer.$route.query.locale= outer.locale;
                outer.$router.push({path:'/sign-in', query: outer.$route.query});
              } else if(emailDomain.includes("WEB.DE")) {
                localStorage.setItem("emailDomain", "WEB.DE")
              } else if(emailDomain.includes("ZOHO")) {
                localStorage.setItem("emailDomain", "ZOHO")
              } else if(emailDomain.includes("GMX")) {
                localStorage.setItem("emailDomain", "GMX")
              } else if(emailDomain.includes("ICLOUD") || emailDomain.includes("ME")){
                localStorage.setItem("emailDomain","ICLOUD");
                outer.$route.query.locale= outer.locale;
                outer.$router.push({path:'/sign-in', query: outer.$route.query});
              }else if(emailDomain.includes("T-ONLINE")){
                localStorage.setItem("emailDomain","T-ONLINE")
                outer.$router.push({path:'/sign-in', query: outer.$route.query});
              }
            }
          })
          .catch(function (response) {
            outer.callOverlayToggle();
            if (
                response &&
                response.response &&
                response.response.data &&
                response.response.data.message &&
                response.response.data.messageCode
            ) {
              outer.showError = true;
              outer.errorResponse = response.response.data.messageCode ;
            }
          });
    },
  }
}
</script>

<style>
.padding-left {
  padding-left: 10px;
}
wb-radio-button{
  height: auto;
}

.radio-align{
  text-align: left;
  padding:10px;
}
.radio-box{
  display: block;
  width:45%;
  margin-left: auto;
  margin-right: auto;
  margin-top:120px;
  margin-bottom: auto;
  background: white;
}
.redirectCls{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#overlay
{
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
}
#text
{
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 50px;
  color: white;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
h1 {
  font-weight: 500;
  font-size: 2.6rem;
  top: -10px;
  text-align: center;
}
h3 {
  text-align: center;
}
.font-style{
  font-size: 25px;
  font-weight: bold;
}
.mb-20 {
  margin-bottom: 20%;
}
</style>